import React, { useContext, useEffect } from 'react';
import { TableContext } from './Table';
import ModalFactory from '../Modal';

const TableData = ({ renderFormat, ...props }) => {
    const { tableData, currentPage, itemsPerPage, tableHeaders, removeTableLayoutFromMemory, setHeaders, defaultHeaders, tableConfig, tableId } = useContext(TableContext);

    useEffect(() => {
        const children = getPage(currentPage);
        if (!tableConfig[tableId]) return;

        if (children.length) {
            console.log(tableHeaders.length, children.length)
            if (tableHeaders.length !== children.length) {
                removeTableLayoutFromMemory();
                setHeaders([...defaultHeaders]);
                ModalFactory.show({
                    title: 'New table Data',
                    body: 'An update to the table has occurred. The saved layouts have been reset.'
                })
            }
        }
    }, [tableData])

    const getPage = (page) => {
        page = (page - 1) * itemsPerPage;
        return tableData
            .slice(page, page + itemsPerPage)
            .map((e, i) => {
                const page = renderFormat(e, i, tableData)
                return page
            })
    }

    return tableData.length ? (
        <tbody>
            {getPage(currentPage).map(e => {
                const { children, ...props } = e.props;

                const temp = [children].flat().map((e, i) => {
                    const config = tableHeaders[i] ?? {}
                    return {
                        show: config.show ?? true,
                        order: config.order ?? i,
                        child: e,
                    }
                })

                const filteredChildren = temp
                    .filter((e) => e.show)
                    .sort((a, b) => a.order - b.order)
                    .map(e => e.child);

                return filteredChildren.length ? {
                    ...e,
                    props: { ...props, children: filteredChildren }
                } : null;
            })}
        </tbody>
    ) : null;
}

export default TableData;